import { Box } from "@mui/system"
import React, { useEffect, useState } from "react"
import { Pagination, Stack, CircularProgress, Typography, Grid } from "@mui/material"

import { connect } from 'react-redux';
import { useSnackbar } from "notistack";

import invoicesService from "../../services/invoicesService"
import { InvoiceItem } from "./invoice-item"
import { SortingSelect } from "../sorting-select"
import { PageSizeSelect } from "../page-size-select"
import noContentImg from "../../img/icons/no-invoices.png"

const InvoiceList = (props) => {
    const { enqueueSnackbar } = useSnackbar();
    const [sortingOptions, setSortingOptions] = useState([]);

    useEffect(() => {
        props.onLoadingPage(props, 0, enqueueSnackbar);
    }, [props.orderBy, props.pageSize, props.currentCompany]);

    useEffect(() => {
        invoicesService.getInvoiceSortingOptions()
            .then(setSortingOptions)
            .catch(() => {});
    }, []);

    const handlePaginationChange = (e, newPage) => {
        props.onLoadingPage(props, newPage, enqueueSnackbar);
    }

    return (
        <React.Fragment>
            {props.isLoading 
            ? 
                <CircularProgress />
            :
                <>
                {
                    props.invoices.length > 0
                    ?
                        <>
                            <Box className='invoices_container_header' >
                                <Grid container className='invoices_container_inner'>
                                    <Grid item xs={3}>
                                        <Typography>Сортировать по:</Typography>
                                        <SortingSelect
                                            value={props.orderBy}
                                            onChange={props.onChangeSorting}
                                            options={sortingOptions}
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Typography>Счетов на странице:</Typography>
                                        <PageSizeSelect
                                            value={props.pageSize}
                                            onChange={props.onChangePageSize}
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box className="invoices_list">
                                {props.invoices.map((invoice, key) => <InvoiceItem key={key} invoice={invoice} />)}
                            </Box>
                            <Box sx={{ mt: 2 }}>
                            <Stack spacing={2}>
                                <Pagination page={props.currentPage} count={props.pagesCount} onChange={handlePaginationChange} />
                            </Stack>
                            </Box>
                        </>
                    :
                    <Box className="no_item_block">
                        <Box className="no_item_block_icon">
                            <img src={noContentImg}/>
                        </Box>
                        <Box className="no_item_block_text_main">
                            Упс... кажется на данный момент у вас нет ни одного выставленного счета.
                        </Box>
                        <Box className="no_item_block_text_second">
                            При заключении с нами договора вы сможете увидеть выставленные вам счета в этом разделе.
                        </Box>
                    </Box>
                }
                </>
            }
		</React.Fragment>
    )
}

function mapStateToProps(state) {
    return {
        currentPage: state.invoicesState.currentPage,
        pagesCount: state.invoicesState.pagesCount,
        pageSize: state.invoicesState.pageSize,
        orderBy: state.invoicesState.orderBy,
        invoices: state.invoicesState.invoices,
        isLoading: state.invoicesState.isLoading,
        currentCompany: state.profileState.currentCompany
    }
}

function mapDispatchToProps(dispatch) {
    return {
        onLoadingPage: (state, pageNumber, enqueueSnackbar) => {
            const pageAction = {
                type: 'CURRENT_PAGE_CHANGED',
                currentPage: 'invoices'
            };
            if (state.currentCompany) {
                dispatch(pageAction);
                const action = {
                    type: 'INVOICES_LOAD_STARTED'
                };
                dispatch(action);
                if (state.currentCompany.Id) {
                invoicesService.getInvoices(pageNumber, state.pageSize, state.orderBy, state.currentCompany.Id)
                    .then((result) => {
                        const action = {
                            type: 'INVOICES_PAGE_LOADED', 
                            pagesCount: result.TotalPages,
                            currentPage: result.PageNumber,
                            invoices: result.Items
                        };
                        dispatch(action);
                    })
                    .catch((error) => {
                        enqueueSnackbar(`Произошла ошибка. ${error.Message ? error.Message : ''}`, { variant: "error" });
                        const action = {
                            type: 'INVOICES_LOAD_ERROR'
                        };
                        dispatch(action);
                    });
                } else {
                    const action = {
                        type: 'INVOICES_PAGE_LOADED', 
                        pagesCount: 1,
                        currentPage: 0,
                        invoices: []
                    };
                    dispatch(action);
                }
            }
        },
        onChangeSorting: (value) => {
            const action = {
                type: 'INVOICES_SORTING_CHANGED',
                value: value
            };
            dispatch(action);
        },
        onChangePageSize: (value) => {
            const action = {
                type: 'INVOICES_PAGE_SIZE_CHANGED',
                value: value
            };
            dispatch(action);
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceList)
